import type { OptimisationDrillHoleProperties } from '~types';
import { formatTooltipFromFields, type TooltipField } from '~utils';

const OPTIMISATION_TOOLTIP_FIELDS: TooltipField<OptimisationDrillHoleProperties>[] = [
  { label: 'Hole', getValue: (hole) => hole.hole_name },
  { label: 'Depth', getValue: (hole) => hole.depth, format: (value) => `${Number(value).toFixed(2)}m` },
  { label: 'Diameter', getValue: (hole) => hole.diameter, format: (value) => `${(Number(value) * 1000).toFixed(0)}mm` },
  { label: 'Burden', getValue: (hole) => hole.burden, format: (value) => `${Number(value).toFixed(2)}m` },
  { label: 'Spacing', getValue: (hole) => hole.spacing, format: (value) => `${Number(value).toFixed(2)}m` },
  { label: 'Dip', getValue: (hole) => hole.dip, format: (value) => `${Number(value).toFixed(0)}°` },
  { label: 'Bearing', getValue: (hole) => hole.bearing, format: (value) => `${Number(value).toFixed(0)}°` },
  { label: 'Blast MJ', getValue: (hole) => hole.blast_mj, format: (value) => Number(value).toFixed(1) },
  { label: 'Crush MJ', getValue: (hole) => hole.crush_mj, format: (value) => Number(value).toFixed(1) },
  { label: 'Dig MJ', getValue: (hole) => hole.dig_mj, format: (value) => Number(value).toFixed(1) },
  { label: 'Drill MJ', getValue: (hole) => hole.drill_mj, format: (value) => Number(value).toFixed(1) },
];

/**
 * Format drill hole data for tooltip display
 * @param {OptimisationDrillHoleProperties} hole - The drill hole data
 * @returns {string} Formatted tooltip string
 */
export const formatTooltip = (hole: OptimisationDrillHoleProperties): string => {
  return formatTooltipFromFields(hole, OPTIMISATION_TOOLTIP_FIELDS);
};
